/**
 * 异步加载 webfont（独立 chunk），不阻塞 main.css / 首屏解析。
 * 字体族与字重见下方 import；加载前由 CSS 回退栈（PingFang / 微软雅黑等）兜底。
 * 首次拉取后由 Service Worker + HTTP immutable 缓存留存，二次访问从本地读取。
 */
let loadPromise;

export function scheduleWebfontLoad() {
  if (!loadPromise) {
    loadPromise = import(
      /* webpackChunkName: "webfonts" */
      '@styles/webfonts.js'
    );
  }
  return loadPromise;
}
